// src/admin/sections/AdminContacts.jsx

import { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  deleteDoc,
  doc,
  query,
  orderBy
} from "firebase/firestore";

import { db } from "../firebase/config";
import './AdminContacts.css';
export default function AdminContacts() {

  const [messages, setMessages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // ================= LOAD REALTIME =================
  useEffect(() => {
    const q = query(
      collection(db, "contacts"),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setMessages(data);
    });

    return () => unsub();
  }, []);

  // ================= DELETE =================
  const deleteMessage = async (id) => {
    if (!window.confirm("Delete this message?")) return;

    await deleteDoc(doc(db, "contacts", id));
  };

  return (
    <div className="admin-section admin-contacts">

      <h2>Contact Messages</h2>

      {/* LIST */}
      <div className="contacts-list">

        {messages.length === 0 && <p>No messages yet</p>}

        {messages.map((msg, index) => (
          <div key={msg.id} className="contact-item">

            {/* HEADER */}
            <div
              className="contact-header"
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              <div>
                <h4>{msg.name || "No Name"}</h4>
                <span>{msg.email}</span>
              </div>

              <small>
                {msg.createdAt?.toDate().toLocaleString() || ""}
              </small>
            </div>

            {/* BODY */}
            {activeIndex === index && (
              <div className="contact-body">

                <p><strong>Subject:</strong> {msg.subject || "-"}</p>

                <p className="message-text">
                  {msg.message}
                </p>

                <button
                  className="delete-btn"
                  onClick={() => deleteMessage(msg.id)}
                >
                  Delete
                </button>

              </div>
            )}

          </div>
        ))}

      </div>

    </div>
  );
}